import { useAuthStore } from '~/stores/useAuthStore'
import { useModulePurchasePrompt } from '~/composables/useModulePurchasePrompt'

/**
 * Users without an active subscription may only open /dashboard/subscription
 * and /dashboard/tickets.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.path.startsWith('/dashboard')) return
  if (to.path === '/dashboard/subscription' || to.path.startsWith('/dashboard/subscription/')) {
    return
  }
  if (to.path === '/dashboard/tickets' || to.path.startsWith('/dashboard/tickets/')) {
    return
  }

  const auth = useAuthStore()
  if (!auth.hydrated) {
    await auth.hydrate()
  }

  const role = auth.user?.siteRole
  const staff = role === 'secretary' || role === 'doctor'
  if (to.path === '/dashboard/unavailable' || to.path.startsWith('/dashboard/unavailable/')) {
    if (staff && !auth.hasActiveSubscription) return
    return navigateTo(staff ? '/dashboard/booking' : '/dashboard')
  }

  if (!auth.hasActiveSubscription) {
    if (staff) return navigateTo('/dashboard/unavailable')
    return navigateTo('/dashboard/subscription')
  }

  if (staff) return
  const moduleByPrefix: Array<{ prefix: string; key: string; title: string }> = [
    { prefix: '/dashboard/booking', key: 'onlineBooking', title: 'نوبت‌دهی و ویزیت مجازی' },
    { prefix: '/dashboard/health', key: 'healthRecord', title: 'سوابق سلامت' },
    { prefix: '/dashboard/blog', key: 'blog', title: 'بلاگ و مقالات' },
    { prefix: '/dashboard/campaign', key: 'clinicCampaign', title: 'کمپین فروش' },
    { prefix: '/dashboard/leads', key: 'leadGen', title: 'جمع‌آوری مشتری' },
    { prefix: '/dashboard/services', key: 'servicePackages', title: 'پکیج جلسات' },
  ]
  const multiModuleRoute = to.path === '/dashboard/reception' || to.path.startsWith('/dashboard/reception/')
  const required = multiModuleRoute
    ? { keys: ['onlineBooking', 'healthRecord'], title: 'لیست بیماران' }
    : (() => {
        const match = moduleByPrefix.find(item =>
          to.path === item.prefix || to.path.startsWith(`${item.prefix}/`),
        )
        return match ? { keys: [match.key], title: match.title } : null
      })()

  if (required) {
    const { enabledKeys } = useSiteModules()
    if (!required.keys.some(key => enabledKeys.value.has(key))) {
      const moduleKey = required.keys[0]!
      const { openModulePurchase } = useModulePurchasePrompt()
      if (import.meta.server) {
        return navigateTo({ path: '/dashboard/subscription', query: { module: moduleKey } })
      }
      openModulePurchase(moduleKey, required.title)
      return false
    }
  }
})
